import history from 'history/browser'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import store from '../../engine/store'
import './Bloc.css'
import { Event } from '../../engine/MetricsManager'

class BlocParcoursComparer extends Component {
    constructor(props) {
        super(props)
        this.handleClickBloc = this.handleClickBloc.bind(this)
    }

    handleClickBloc() {
        if (this.props.gtm_id) {
            Event(this.props.gtm_id, 'me.click')
        }

        if (
            this.props.linked_data_id &&
            this.props.linked_data_value !== undefined
        ) {
            store.dispatch({
                type: 'SET',
                value: {
                    key: this.props.linked_data_id,
                    value: this.props.linked_data_value,
                },
            })
        }
        if (this.props.linked_data_id && this.props.linked_data_value_empty) {
            store.dispatch({
                type: 'SET',
                value: { key: this.props.linked_data_id, value: undefined },
            })
        }
        if (this.props.targetView) {
            store.dispatch({
                type: 'SET',
                value: { key: 'prj_maturite', value: 'TROUVE' },
            })
            history.push('/tunnelmobile/', {
                targetView: this.props.targetView,
            })
        }
    }

    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in  bloc-gauche-2 pointer '
        const style = {}

        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////
        style.height = '301px'
        var premadeContent = (
            <div className="firstChoiceStyle">
                <img src="svg/3min.svg" className="timer" alt="timer" />
                <div className="title bold-font">
                    Comparez votre offre de prêt
                </div>
                <div className="subtitle">Je challenge ma banque</div>
                <div className="bottomImageContainer">
                    <img
                        src="svg/balance.svg"
                        className="balance"
                        alt="balance"
                    />
                </div>
            </div>
        )

        return (
            <div>
                <div
                    className={className}
                    style={style}
                    onClick={() => this.handleClickBloc()}
                >
                    {premadeContent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        targetDataValue: state.answer[ownProps.linked_data_id],
    }
}

export default connect(mapStateToProps)(BlocParcoursComparer)
